import formatDate from "@/utils/date/format";
import newDateWrapper from "@/utils/date/new-date-wrapper";

export default [
  {
    path: "/receivables",
    component: () => import(/* webpackChunkName: "Receivables" */ "@/views/receivables/Index.vue"),
    name: "receivables",
    redirect: { name: "invoices-list" },
    meta: {
      bypassCacheKeyCheck: true,
      requireAuth: true,
      title: "",
    },
    children: [
      {
        path: "clients-invoicing",
        component: () => import(/* webpackChunkName: "ClientsInvoicing" */ "@/views/receivables/clients-invoicing/Index.vue"),
        name: "clients-invoicing",
        children: [
          {
            path: "",
            component: () => import(/* webpackChunkName: "ClientsInvoicesList" */ "@/views/receivables/clients-invoicing/List.vue"),
            name: "invoices-list",
            meta: {
              hasFilters: true,
              filtersScheme: {
                cycle: formatDate({
                  date: newDateWrapper([newDateWrapper()
                    .getFullYear(), newDateWrapper()
                    .getMonth(), 1]),
                  options: {
                    year: "numeric",
                    month: "2-digit",
                  },
                  locale: "fr-CA",
                }),
                legalEntity: "",
                campaigns: [],
                invoicingStatus: "",
                invoicingDetails: "",
                needsReviewalOnly: 0,
              },
              showLayout: true,
            },
          },
          {
            path: "manual-invoice",
            component: () => import(/* webpackChunkName: "ManualInvoice" */ "@/views/receivables/clients-invoicing/ManualInvoice.vue"),
            name: "manual-invoicing",
            meta: {
              bypassCacheKeyCheck: true,
              showLayout: false,
            },
          },
          {
            path: "set-invoices",
            component: () => import(/* webpackChunkName: "SetInvoices" */ "@/views/receivables/clients-invoicing/SetInvoices.vue"),
            name: "set-invoice",
            props: true,
            meta: {
              bypassCacheKeyCheck: true,
              showLayout: false,
            },
          },
          {
            path: ":id",
            component: () => import(/* webpackChunkName: "ClientsInvoicingDetails" */ "@/views/receivables/clients-invoicing/details/Index.vue"),
            name: "invoice-details",
            meta: {
              bypassCacheKeyCheck: true,
            },
            children: [
              {
                path: "update",
                component: () => import(/* webpackChunkName: "ClientsInvoicingUpdate" */ "@/views/receivables/clients-invoicing/details/Update.vue"),
                name: "invoice-update",
                meta: {
                  bypassCacheKeyCheck: true,
                  showLayout: false,
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
